import type { SVGProps } from 'react';

const SvgData = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M.63 23.37v5.34a2.84 2.84 0 0 0 2.84 2.83h24.46a2.84 2.84 0 0 0 2.84-2.83V3.33A2.84 2.84 0 0 0 27.93.49H3.47A2.85 2.85 0 0 0 .63 3.33v5.34A8.12 8.12 0 0 0 5.33 16a8.12 8.12 0 0 0-4.7 7.37Zm8.1-6.6h3.64a6.66 6.66 0 1 0 0-1.5H8.73a6.61 6.61 0 0 1-6.6-6.6V3.33A1.34 1.34 0 0 1 3.47 2h24.46a1.34 1.34 0 0 1 1.34 1.34v25.37A1.33 1.33 0 0 1 27.93 30H3.47a1.33 1.33 0 0 1-1.34-1.33v-5.3a6.61 6.61 0 0 1 6.6-6.6Zm5.1-.75A5.16 5.16 0 1 1 19 21.18 5.16 5.16 0 0 1 13.83 16Z"
      data-name="data"
    />
  </svg>
);

export default SvgData;
